import { jsxs as l, jsx as s } from "react/jsx-runtime";
import { useState as w, useEffect as u } from "react";
function d({ clientId: t, redirectURI: n, scope: o = "user_read" }) {
  const [e] = w(g(15));
  return sessionStorage.twitchOAuthState = e, "https://id.twitch.tv/oauth2/authorize?response_type=token&client_id=" + t + "&redirect_uri=" + n + "&state=" + e + "&scope=" + o;
}
function g(t) {
  let n = "";
  const o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (let e = 0; e < t; e++)
    n += o.charAt(Math.floor(Math.random() * o.length));
  return n;
}
async function p({ twitchOAuthToken: t, login: n = null, clientId: o }) {
  var i;
  const e = new URL("https://api.twitch.tv/helix/users");
  n && e.searchParams.append("login", n);
  const r = await (await fetch(e.toString(), {
    method: "GET",
    headers: new Headers({
      Accept: "application/json",
      "Client-ID": o,
      Authorization: "Bearer " + t
    })
  })).json();
  return (i = r == null ? void 0 : r.data) == null ? void 0 : i[0];
}
function k({ onOAuth: t = (o) => {
}, pathname: n = "/twitch-callback" }) {
  function o(e) {
    var r, i, c, a;
    if (!(e.origin !== window.origin || !((i = (r = e.source) == null ? void 0 : r.location) != null && i.pathname) || ((a = (c = e.source) == null ? void 0 : c.location) == null ? void 0 : a.pathname) !== n))
      try {
        window.sessionStorage.setItem("twitchOAuthToken", e.data.twitchOAuthToken), t(e.data.twitchOAuthToken);
      } catch {
        console.error("Error parsing message data", e.data);
      }
  }
  u(() => (window.addEventListener("message", o), () => {
    window.removeEventListener("message", o);
  }), []);
}
const f = "#9146FF";
function T({ clientId: t, redirectURI: n, scope: o, children: e, className: r = "" }) {
  const i = d({ clientId: t, redirectURI: n, scope: o });
  return /* @__PURE__ */ l("button", { className: r, onClick: () => {
    window.open(i).focus();
  }, style: { backgroundColor: f, color: "#fff" }, children: [
    /* @__PURE__ */ s(m, {}),
    e
  ] });
}
function b({ clientId: t, redirectURI: n, scope: o, onSignIn: e = (r) => {
} }) {
  const [r, i] = w(null);
  u(() => {
    i(sessionStorage.getItem("twitchUsername"));
  }, []), k({
    onOAuth: (a) => {
      p({ twitchOAuthToken: a, clientId: t }).then((h) => {
        sessionStorage.setItem("twitchUsername", h.login), i(h.login);
      }), a && e(!0);
    }
  });
  function c() {
    sessionStorage.removeItem("twitchOAuthToken"), sessionStorage.removeItem("twitchUsername"), i(null), e(!1);
  }
  return r ? /* @__PURE__ */ l("button", { style: { backgroundColor: f, color: "#fff" }, onClick: c, children: [
    /* @__PURE__ */ s(m, {}),
    " ",
    r,
    " (sign out)"
  ] }) : /* @__PURE__ */ s(T, { clientId: t, redirectURI: n, scope: o, children: "Sign Into Twitch" });
}
function m({ width: t = "32", height: n = "32", className: o = "" }) {
  return /* @__PURE__ */ s(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: t,
      height: n,
      viewBox: "0 0 32 32",
      fill: "currentColor",
      className: o,
      children: /* @__PURE__ */ s("path", { d: "M26.711 14.929l-4.284 4.284h-4.285l-3.749 3.749v-3.749h-4.82V3.146h17.138zM8.502 1.004L3.146 6.36v19.279h6.427v5.356l5.356-5.356h4.284l9.641-9.64V1.003zm12.854 5.891h2.142v6.427h-2.142zm-5.892 0h2.143v6.427h-2.144z" })
    }
  );
}
function A() {
  u(() => {
    let t = null;
    window.location.hash.match(/access_token=(\w+)/) && (t = S(location.hash)), t && (window.opener.postMessage({ twitchOAuthToken: t }, "*"), window.close());
  }, []);
}
function C({ children: t = /* @__PURE__ */ s("h1", { children: "Redirecting..." }) }) {
  return A(), { ...t };
}
function S(t) {
  const n = function(e) {
    const r = t.match(e);
    return r ? r[1] : null;
  }, o = n(/state=(\w+)/);
  if (sessionStorage.twitchOAuthState == o)
    return n(/access_token=(\w+)/);
}
export {
  T as TwitchButton,
  C as TwitchCallbackPage,
  m as TwitchIcon,
  b as TwitchSignIn,
  p as getUserData,
  g as nonce,
  f as twitchPurple,
  A as useTwitchCallback,
  d as useTwitchImplicitAuthUrl,
  k as useTwitchOAuth
};
